import Icon from '../components/Icon.vue'

Icon.register({
  'cookie-bite': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M510.5 255.8C440.6 255 384.1 198.1 384.1 128 313.9 128 257.1 71.5 256.2 1.5 228.9-2.6 201.1 1.8 176.5 14.3L107.3 49.6A132.2-132.2 0 0 1 49.5 107.4L14.4 176.2A132.6-132.6 0 0 1 1.6 257.2L13.7 333.5A132.5-132.5 0 0 1 50.9 406.4L105.6 461.2A132-132 0 0 1 178.3 498.2L255.1 510.4C282.6 514.7 310.8 510.3 335.6 497.6L404.7 462.4A132.3-132.3 0 0 1 462.5 404.6L497.6 335.7C510.2 311.1 514.6 283.1 510.5 255.8zM176 368C158.3 368 144 353.7 144 336S158.3 304 176 304 208 318.3 208 336 193.7 368 176 368zM208 208C190.3 208 176 193.7 176 176S190.3 144 208 144 240 158.3 240 176 225.7 208 208 208zM368 336C350.3 336 336 321.7 336 304S350.3 272 368 272 400 286.3 400 304 385.7 336 368 336z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cookie-bite.js
// module id = +QMa
// module chunks = 144